<template>
  <PageTemplate>
    <div class="d-flex justify-content-between">
      <h6 class="element-header">
        {{ $t('general.change_password') }}
      </h6>
    </div>

    <div class="element-box">
      <h5 class="form-header mb-4">
        Mitarbeiter - {{ piniaCurrentUser?.firstName }} {{ piniaCurrentUser?.lastName }}
      </h5>

      <form @submit.prevent="changePassword" novalidate>
        <div class="row">
          <div class="col-lg-4">
            <BaseInput v-model="formData.currentPassword"
                       type="password"
                       label="Aktuelles Passwort"
                       :required=true
                       :validation="v$.currentPassword"
                       :messages="v$.currentPassword.required.$message">
            </BaseInput>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4">
            <BaseInput v-model="formData.password"
                       type="password"
                       label="Neues Passwort"
                       :required=true
                       :validation="v$.password"
                       :messages="v$.password.$errors[0]?.$message">
            </BaseInput>
          </div>
        </div>
        <div class="form-buttons-w">
          <button class="btn btn-primary" type="submit">Bestätigen</button>
        </div>
      </form>
    </div>
  </PageTemplate>
</template>
<script setup>
import securityService from '@/api/Security/index';
import BaseInput from '@/components/base/BaseInput.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import { ErrorToast, SuccessToast } from '@/components/VueToast';
import router from '@/router';
import { passwordRule, requiredRule } from '@/shared/validators/validationRules';
import { piniaUserStore } from '@/store/piniaUserStore';
import useVuelidate from '@vuelidate/core';
import { helpers } from '@vuelidate/validators';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const piniaUserState   = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);

const { t }    = useI18n();
const formData = ref({
  currentPassword: '',
  password: '',
});

const rules = computed(() => {
  return {
    currentPassword: requiredRule(t),
    password: {
      ...passwordRule(t),
      notSameAsCurrent: helpers.withMessage(
          t('form_validation.password_same_as_current'),
          (value) => !value || value !== formData.value.currentPassword
      ),
    },
  };
});

const v$ = useVuelidate(rules, formData);

async function changePassword() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  try {
    // Old token is invalid after the password change, backend returns a new one
    const {data} = await securityService.changePassword(formData.value);
    localStorage.setItem('token', data.data.token);
    await router.push({ path: '/dashboard/info' });
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}
</script>